import { writable } from "svelte/store";

export const mapDeletedPromptStore = writable(false);
